import { useEffect, useState } from "react";
import { Ticket, IndianRupee, Users, Gamepad2, MapPin } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import api from "@/lib/api";

const COLORS = ["#8b5cf6", "#10b981", "#f59e0b", "#ef4444", "#3b82f6"];

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <p className="text-slate-400">Loading…</p>;

  const cards = [
    { label: "Revenue (paid)", value: `₹${s.revenue}`, icon: IndianRupee, color: "text-emerald-400" },
    { label: "Bookings", value: s.total_bookings, icon: Ticket, color: "text-violet-400" },
    { label: "Players hosted", value: s.players, icon: Users, color: "text-amber-400" },
    { label: "Games / Locations", value: `${s.games} / ${s.locations}`, icon: Gamepad2, color: "text-sky-400" },
  ];

  return (
    <div>
      <h1 className="font-display font-extrabold text-3xl mb-1">Dashboard</h1>
      <p className="text-slate-400 mb-6">Live overview of Escape Room Express.</p>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {cards.map((c) => (
          <div key={c.label} className="rounded-2xl border border-white/10 bg-[#131a29] p-5" data-testid={`stat-${c.label}`}>
            <c.icon className={`h-6 w-6 ${c.color}`} />
            <div className="font-display font-extrabold text-2xl mt-3">{c.value}</div>
            <div className="text-xs text-slate-400 mt-1">{c.label}</div>
          </div>
        ))}
      </div>
      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 rounded-2xl border border-white/10 bg-[#131a29] p-5">
          <h3 className="font-display font-semibold mb-4">Revenue timeline</h3>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={s.timeline}>
              <XAxis dataKey="date" stroke="#64748b" fontSize={11} tickFormatter={(d) => d?.slice(5)} />
              <YAxis stroke="#64748b" fontSize={11} />
              <Tooltip contentStyle={{ background: "#0d1320", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12 }} />
              <Bar dataKey="revenue" fill="#8b5cf6" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="rounded-2xl border border-white/10 bg-[#131a29] p-5">
          <h3 className="font-display font-semibold mb-4">Bookings by game</h3>
          {s.by_game.length ? (
            <ResponsiveContainer width="100%" height={260}>
              <PieChart>
                <Pie data={s.by_game} dataKey="value" nameKey="name" innerRadius={50} outerRadius={90} paddingAngle={3}>
                  {s.by_game.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Tooltip contentStyle={{ background: "#0d1320", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12 }} />
              </PieChart>
            </ResponsiveContainer>
          ) : <p className="text-slate-500 text-sm">No paid bookings yet.</p>}
          <div className="flex flex-wrap gap-2 mt-2">
            {s.by_game.map((g, i) => <span key={g.name} className="text-xs text-slate-400"><span className="inline-block h-2 w-2 rounded-full mr-1" style={{ background: COLORS[i % COLORS.length] }} />{g.name} ({g.value})</span>)}
          </div>
        </div>
      </div>
    </div>
  );
}
